import React from 'react'
import '../css/services.css'


import '../css/section.css'

import pry from '../img/priy.jpg'
import { Link } from 'react-router-dom'

const Services = () => {
    return (
        <>

            <section class="section-services">
                <div class="container">
                    <div class="row justify-content-center text-center">
                        <div class="col-md-10 col-lg-8">
                            <div class="header-section">
                                <h2 class="title">General   Treatment </h2>
                                <p class="description">To provide best treatment patient and accept challenges throughout continuos dedicated and persevesion in the duty to be performed</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fab fa-battle-net"></i>
                                    </span>
                                    <h3 class="title">General Medicine</h3>
                                    <p class="description">General physicians provide primary care for a range of common health issues such as fever, flu, and infections. They also manage chronic conditions like diabetes and hypertension.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fab fa-asymmetrik"></i>
                                    </span>
                                    <h3 class="title">Emergency Care</h3>
                                    <p class="description">Physicians provide immediate medical attention for acute conditions and injuries, including trauma care, heart attacks, and respiratory distress.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fab fa-artstation"></i>
                                    </span>
                                    <h3 class="title">Preventive Care</h3>
                                    <p class="description">General physicians help in disease prevention, including vaccinations, screenings, and lifestyle advice to ensure long-term health and well-being.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>



                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-stethoscope"></i>
                                    </span>
                                    <h3 class="title">Mild Illnesses</h3>
                                    <p class="description">Comprehensive care for minor health issues such as colds, fatigue, and other common ailments. Early detection and prevention for better well-being.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-first-aid"></i>
                                    </span>
                                    <h3 class="title">Injuries</h3>
                                    <p class="description">Treatment and care for minor injuries such as sprains, cuts, and bruises, with a focus on swift recovery and effective healing solutions.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-clinic-medical"></i>
                                    </span>
                                    <h3 class="title">Chronic Conditions</h3>
                                    <p class="description">Ongoing management and treatment for asthma, skin conditions, and other chronic illnesses, helping you maintain a healthy lifestyle.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-clinic-medical"></i>
                                    </span>
                                    <h3 class="title">Blood Pressure</h3>
                                    <p class="description">Blood pressure is the force of blood pushing against the walls of your arteries as your heart pumps blood around your body. </p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-clinic-medical"></i>
                                    </span>
                                    <h3 class="title">Diabetes</h3>
                                    <p class="description">Diabetes is a chronic disease that occurs when the body has high levels of blood sugar, or glucose</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>


                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-clinic-medical"></i>
                                    </span>
                                    <h3 class="title">Headache </h3>
                                    <p class="description">A headache is pain or discomfort in the head or face, and can be a common cause of pain and missed work or school. Headaches can vary in how often they occur, </p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>




                    </div>
                </div>
            </section>




            <br /><br />


            <section className="about-section">
                <div className="container">
                    <div className="row">

                        {/* Image Column */}
                        <div className="image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="">

                                <figure className="image-1">
                                    <a href="#" className="lightbox-image" data-fancybox="images">
                                        <img
                                            title="Rahul Kumar Yadav"
                                            src={pry} />
                                    </a>
                                </figure>
                            </div>
                        </div>


                        {/* Content Column */}
                        <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                            <div className="inner-column">
                                <div className="sec-title">
                                    <span className="title">About  Doctor </span>
                                    <h2> Dr. Priyanka  pandey</h2>
                                    <h3>B.D.S , M.I.D.A.  Dental Surgeon </h3>

                                </div>
                                <div className="text" style={{ marginTop: '-30px' }}>
                                    I am a dental surgeon and have completed my BDS from Saraswati Dental College and Hospital Lucknow
                                    Presently working as Lecturer at Saraswati Dental College and Hospital  Lucknow
                                    All dental problems are diagnosed and treated with proper counseling and medication at my clinic
                                </div>

                                <div className="btn-box">
                                    <Link t0='/Priyanka'>  <a href="#" className="theme-btn btn-style-three">Read More </a></Link>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </section>


            <section class="section-services">
                <div class="container">
                    <div class="row justify-content-center text-center">
                        <div class="col-md-10 col-lg-8">
                            <div class="header-section">
                                <h2 class="title">  Dental  Treatment </h2>
                                <p class="description">To provide best treatment patient and accept challenges throughout continuos dedicated and persevesion in the duty to be performed</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">




                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fab fa-500px"></i>
                                    </span>
                                    <h3 class="title">General Dentistry</h3>
                                    <p class="description">Dentists provide primary dental care, including routine check-ups, cleanings, fillings, and treatment of common oral issues like tooth decay and gum disease.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-chart-pie"></i>
                                    </span>
                                    <h3 class="title">R.C.T. </h3>
                                    <p class="description">R.C.T. offer services like teeth whitening, veneers, bonding, and reshaping to improve the appearance of your teeth and smile.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="single-service">
                                <div class="content">
                                    <span class="icon">
                                        <i class="fas fa-laptop-code"></i>
                                    </span>
                                    <h3 class="title">Scaling</h3>
                                    <p class="description">Scaling specialize in straightening teeth, correcting bite issues, and offering braces or clear aligners to achieve a better dental structure.</p>
                                    <a href="#" class="learn-more">Learn More</a>
                                </div>
                                <span class="circle-before"></span>
                            </div>
                        </div>

                    </div>
                </div>
            </section>




        </>
    )
}

export default Services